// TODO: uncomment whe AppV1 is removed
// import Modal from 'react-modal';
// import { toast } from 'react-toastify';

import { CssBaseline } from '@material-ui/core';
import { ThemeProvider } from '@mui/material/styles';
// import 'react-toastify/dist/ReactToastify.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { RoutesV2 } from './RoutesV2';

import { lightTheme } from '../../themes/light';
import GtmUserTrack from '../GtmUserTrack/GtmUserTrack';
// import '../../App.css';

// toast.configure();
// Modal.setAppElement('body');

const queryClient = new QueryClient();

export const AppV2 = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider theme={lightTheme}>
      <CssBaseline />
      <div className="App">
        <GtmUserTrack />
        <RoutesV2 />
      </div>
    </ThemeProvider>
  </QueryClientProvider>
);
